<template>
  <el-dialog
    title="编辑志愿"
    :visible.sync="dialogVisible"
    append-to-body
    top="2vh"
    v-loading="loading"
    width="30%"
  >
     <div style="font-size: 18px;color: red;width: 100%;text-align: center;margin-bottom: 20px;font-weight: bold;" v-if="userinfo && userinfo.role==1">
       升级VIP可享所有服务
     </div>
     <el-form :model="form" ref="form" label-width="80px" v-if="$parent.detail" :rules="rules">
         <!-- 姓名 -->
         <el-row>
           <el-col :span="24">
             <el-form-item prop="name">
               <template slot="label">
                 <span>姓名 </span>
               </template>
               <el-input
                 tabindex="1"
                 v-model="form.name"
                 autoComplete="off"
                 clearable
                 placeholder="请输入姓名"
               >
               </el-input>
             </el-form-item>
           </el-col>
         </el-row>
         <!-- 性别 -->
         <el-row>
           <el-col :span="24">
             <el-form-item prop="sex">
               <template slot="label">
                 <span>性别 </span>
               </template>
               <el-radio-group v-model="form.sex">
                 <el-radio :label="parseInt(1)">男</el-radio>
                 <el-radio :label="parseInt(2)">女</el-radio>
               </el-radio-group>
             </el-form-item>
           </el-col>
         </el-row>
         <!-- 批次 -->
         <!-- 省份 -->
         <el-row>
           <el-col :span="24">
             <el-form-item prop="province">
               <template slot="label">
                 <span>省份 </span>
               </template>
               <div class="tianbaos" @click="shengfen">
                 <img src="@/assets/address.png" alt="" />
                 {{form.province || "请选择"}}
               </div>
             </el-form-item>
           </el-col>
         </el-row>
         <el-row>
           <el-col :span="24">
             <el-form-item prop="score">
               <template slot="label">
                 <span>预估总分 </span>
               </template>
               <el-input
                 tabindex="1"
                 v-model="form.score"
                 autoComplete="off"
                 clearable
                 :disabled="userinfo && userinfo.role!=1?false:true"
                 placeholder="请输入总分"
               >
               </el-input>
             </el-form-item>
           </el-col>
         </el-row>
         <el-row>
           <el-col :span="24">
             <el-form-item prop="batch">
               <template slot="label">
                 <span>批次 </span>
               </template>
               <el-select
                 tabindex="5"
                 style="width: 100%"
                 v-model="form.batch"
                 filterable
                 :disabled="userinfo && userinfo.role!=1?false:true"
                 placeholder="请选择"
               >
                 <el-option
                   key="0"
                   label="本科批"
                   :value="'本科批'"
                 ></el-option>
                 <el-option
                   key="1"
                   label="专科批"
                   :value="'专科批'"
                 ></el-option>
               </el-select>
             </el-form-item>
           </el-col>
         </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item prop="subject">
                <template slot="label">
                  <span>所选科目 </span>
                </template>
                <el-checkbox-group :disabled="userinfo && userinfo.role!=1?false:true" v-model="form.subject" :max="3">
                  <el-checkbox
                    key="0"
                    :disabled="form.subject.includes('历史')"
                    :label="'物理'"
                    >物理</el-checkbox
                  >
                  <el-checkbox key="1" :label="'生物'">生物</el-checkbox>
                  <el-checkbox key="2" :label="'化学'">化学</el-checkbox>
                  <br />
                  <el-checkbox
                    key="3"
                    :disabled="form.subject.includes('物理')"
                    :label="'历史'"
                    >历史</el-checkbox
                  >
                  <el-checkbox key="4" :label="'政治'">政治</el-checkbox>
                  <el-checkbox key="5" :label="'地理'">地理</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
          </el-row>
          <div style="width: 100%;display: flex;align-items: center;justify-content: center;">
            <div class="success" @click="zhineng()" :disabled="loading">
              {{
                loading==false?"立即修改":"修改中..."
              }}
            </div>
          </div>
     </el-form>
     <!--请选择你所在的高考省份-->
     <selectCity ref="provinceData" @provinceSu="provinceSu" />
  </el-dialog>
</template>

<script>
  import {
    mapGetters
  } from "vuex"
  import selectCity from "@/components/selectCity.vue";
  import {
    getUserVooluteer,
    screenFind,
    college_intell_screen,
    college_gaoxiao_screen,
    college_result_screen,
    addAll,deleteAll,update
  } from "@/api/gw/volunteer.js"
  export default{
    components:{
      selectCity
    },
    computed: {
      ...mapGetters(['isLogin', "userinfo"]),
    },
    data(){
      return{
        dialogVisible:false,
        loading:false,
        form:{
          name:"",
          sex:1,
          province:"",//省份
          batch:"本科批",//本科批
          score:"",//总分
          subject:[]
        },
        rules:{
          name: [{ required: true, message: "姓名不能为空", trigger: "change" }],
          sex: [{ required: true, message: "性别不能为空", trigger: "change" }],
          batch: [{ required: true, message: "批次不能为空", trigger: "change" }],
          score: [{ required: true, message: "成绩不能为空", trigger: "blur" }],
          subject: [
            {
              required: true,
              type: "array",
              message: "所选科目不能为空",
              trigger: "change",
            },
          ],
          province: [
            { required: true, message: "省份不能为空", trigger: "blur" },
          ],
        }
      }
    },
    mounted(){
         this.$store.dispatch("getUserInfo");
    },
    methods:{
      shengfen(){
        if(this.userinfo.role==1){
          this.$message.error("升级VIP可修改");
          return;
        }else{
          this.$refs.provinceData.show()
        }
      },
      zhineng(){
        this.$refs["form"].validate((valid) => {
          if (valid) {
            let form = { ...this.form };
            //判断所选科目的物理和历史必选一个
            let subject = form.subject;
            if (!subject.includes("历史") && !subject.includes("物理")) {
              this.$message.error("所选科目物理和历史必选，且二选一");
              return;
            }
            //添加组别
            if (subject.includes("历史")) {
              form["group_d"] = "历史科目组合";
            }
            if (subject.includes("物理")) {
              form["group_d"] = "物理科目组合";
            }
            this.loading = true;
            update(this.form).then(()=>{
              this.$message.success("修改成功")
              this.$parent.getUserVooluteer();
              this.dialogVisible = false
            }).finally(()=>{
              this.loading = false
            })
          }
        })
      },
      show(){
        this.$nextTick(()=>{
          this.dialogVisible = true
          this.form = {...this.$parent.detail};
          this.form["subject"] = this.form.subject.split(",")
        })
      },
      provinceSu(item){
        this.form.province = item
      },
    },
  }
</script>

<style lang="scss" scoped>
  .tianbaos {
    display: flex;
    align-items: center;
    margin-left: auto;
    cursor: pointer;
    img {
      width: 14px;
      height: 18px;
      margin-right: 5px;
    }
    font-size: 14px;
  }
  .success{
    width: 360px;
  height: 60px;
  background: #2AA38B;
  box-shadow: 0px 3px 16px 0px rgba(13,108,89,0.48);
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 24px;
  margin-top: 40px;
  cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/views/volunteer/components/edit.vue